"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Person = exports.PeopleList = exports.Features = exports.default = exports.OverviewDiscussionTab = void 0;

var _react = babelHelpers.interopRequireWildcard(require("react"));

var _decorators = require("decorators");

var _exports = babelHelpers.interopRequireDefault(require("exports"));

var _search = require("modals/search");

var _base = require("modals/base");

var _classList = babelHelpers.interopRequireDefault(require("class-list"));

var _Discussion = babelHelpers.interopRequireDefault(require("tab/Discussion"));

var _Discussion2 = babelHelpers.interopRequireDefault(require("components/Discussion"));

var _ProfileImageContainer = babelHelpers.interopRequireDefault(require("components/ProfileImageContainer"));

var _applicationHeader = babelHelpers.interopRequireDefault(require("block/applicationHeader"));

var _ObjectDetailBar = require("components/ObjectDetailBar");

var _class, _descriptor, _temp, _class3, _descriptor2, _descriptor3, _descriptor4, _temp2, _class5, _descriptor5, _descriptor6, _temp3, _class7, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _temp4, _class9, _descriptor14, _descriptor15, _descriptor16, _temp5, _class11, _descriptor17, _temp6, _class13, _descriptor18, _descriptor19, _descriptor20, _descriptor21, _descriptor22, _descriptor23, _descriptor24, _descriptor25, _temp7;

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var OverviewDiscussionTab =
/*#__PURE__*/
function (_DiscussionTab) {
  babelHelpers.inherits(OverviewDiscussionTab, _DiscussionTab);

  function OverviewDiscussionTab() {
    babelHelpers.classCallCheck(this, OverviewDiscussionTab);
    return babelHelpers.possibleConstructorReturn(this, babelHelpers.getPrototypeOf(OverviewDiscussionTab).apply(this, arguments));
  }

  babelHelpers.createClass(OverviewDiscussionTab, [{
    key: "renderTop",
    value: function renderTop() {
      return null;
    }
  }, {
    key: "render",
    value: function render() {
      return _react.default.createElement("div", {
        id: "tab-discussion",
        className: "objectBodyTab container"
      }, this.renderTop(), _react.default.createElement("div", {
        className: "inner-content"
      }, _react.default.createElement("div", {
        className: "container"
      }, _react.default.createElement("h1", null, "Join the Discussion"))), _react.default.createElement("div", {
        className: "objectBodyTab container"
      }, _react.default.createElement("div", {
        id: "discussionRoot"
      }, _react.default.createElement(_Discussion2.default, {
        discussionRoot: this.discussionRoot,
        userId: this.userId,
        trackData: this.trackData
      }))));
    }
  }]);
  return OverviewDiscussionTab;
}(_Discussion.default);

exports.OverviewDiscussionTab = OverviewDiscussionTab;
var OverviewTab = (_class13 = (_temp7 =
/*#__PURE__*/
function (_Component5) {
  babelHelpers.inherits(OverviewTab, _Component5);

  function OverviewTab() {
    var _babelHelpers$getProt7;

    var _this9;

    babelHelpers.classCallCheck(this, OverviewTab);

    for (var _len7 = arguments.length, args = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
      args[_key7] = arguments[_key7];
    }

    _this9 = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt7 = babelHelpers.getPrototypeOf(OverviewTab)).call.apply(_babelHelpers$getProt7, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this9, "summary", _descriptor18, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this9)));
    babelHelpers.initializerDefineProperty(_this9, "description", _descriptor19, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this9)));
    babelHelpers.initializerDefineProperty(_this9, "features", _descriptor20, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this9)));
    babelHelpers.initializerDefineProperty(_this9, "people", _descriptor21, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this9)));
    babelHelpers.initializerDefineProperty(_this9, "tags", _descriptor22, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this9)));
    babelHelpers.initializerDefineProperty(_this9, "discussion", _descriptor23, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this9)));
    babelHelpers.initializerDefineProperty(_this9, "showDiscussion", _descriptor24, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this9)));
    babelHelpers.initializerDefineProperty(_this9, "scholarship", _descriptor25, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this9)));
    return _this9;
  }

  babelHelpers.createClass(OverviewTab, [{
    key: "render",
    value: function render() {
      return _react.default.createElement("div", {
        className: "objectBodyTab container"
      }, this.renderHeader(), !!(this.summary || this.description) && _react.default.createElement("div", {
        id: "courseDescription"
      }, this.renderDescriptionHeader(), this.summary && _react.default.createElement("div", {
        className: "summary"
      }, this.summary), this.description && _react.default.createElement("div", {
        className: "description",
        dangerouslySetInnerHTML: {
          __html: this.description
        }
      })), this.renderScholarship(), this.renderFeatures(), this.renderPeople(), this.renderTags(), this.showDiscussion && this.renderDiscussion(), !this.showDiscussion && _react.default.createElement("div", {
        style: {
          display: 'none'
        }
      }, this.renderDiscussion()));
    }
  }, {
    key: "renderHeader",
    value: function renderHeader() {
      return null;
    }
  }, {
    key: "renderDescriptionHeader",
    value: function renderDescriptionHeader() {
      return null;
    }
  }, {
    key: "renderDiscussion",
    value: function renderDiscussion() {
      if (this.discussion) {
        return _react.default.createElement(OverviewDiscussionTab, this.discussion);
      }

      return null;
    }
  }, {
    key: "renderFeatures",
    value: function renderFeatures() {
      if (!this.features) return null;
      return _react.default.createElement(Features, {
        items: this.features
      });
    }
  }, {
    key: "renderPeople",
    value: function renderPeople() {
      if (!this.people) return null;
      return _react.default.createElement(PeopleList, this.people);
    }
  }, {
    key: "renderTags",
    value: function renderTags() {
      var _this10 = this;

      if (!this.tags || !this.tags.length) return null;
      return _react.default.createElement("div", {
        className: "tag-body"
      }, _react.default.createElement("b", null, "Tags:"), this.tags.map(function (tag) {
        return _react.default.createElement("a", {
          href: "javascript:void(0)",
          key: tag.id,
          onClick: _this10.showTag,
          "data-tag": tag.tag,
          className: "tag"
        }, tag.tag);
      }));
    }
  }, {
    key: "showTag",
    value: function showTag(event) {
      _search.TagSearchModal.show(event.target.dataset.tag);
    }
  }, {
    key: "renderScholarship",
    value: function renderScholarship() {
      if (this.scholarship) {
        return _react.default.createElement("p", {
          className: "scholarship-link"
        }, this.scholarship.title, ' ', _react.default.createElement("a", {
          onClick: this.showScholarship,
          href: "javascript:void(0)"
        }, this.scholarship.linkText));
      }

      return null;
    }
  }, {
    key: "showScholarship",
    value: function showScholarship() {
      var M = new ScholarshipModal(this.scholarship.block);
      M.show();
    }
  }]);
  return OverviewTab;
}(_react.Component), _temp7), (_descriptor18 = babelHelpers.applyDecoratedDescriptor(_class13.prototype, "summary", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor19 = babelHelpers.applyDecoratedDescriptor(_class13.prototype, "description", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor20 = babelHelpers.applyDecoratedDescriptor(_class13.prototype, "features", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor21 = babelHelpers.applyDecoratedDescriptor(_class13.prototype, "people", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor22 = babelHelpers.applyDecoratedDescriptor(_class13.prototype, "tags", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor23 = babelHelpers.applyDecoratedDescriptor(_class13.prototype, "discussion", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor24 = babelHelpers.applyDecoratedDescriptor(_class13.prototype, "showDiscussion", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor25 = babelHelpers.applyDecoratedDescriptor(_class13.prototype, "scholarship", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), babelHelpers.applyDecoratedDescriptor(_class13.prototype, "showTag", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class13.prototype, "showTag"), _class13.prototype), babelHelpers.applyDecoratedDescriptor(_class13.prototype, "showScholarship", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class13.prototype, "showScholarship"), _class13.prototype)), _class13);
exports.default = OverviewTab;

var ScholarshipModal =
/*#__PURE__*/
function (_ReactModal) {
  babelHelpers.inherits(ScholarshipModal, _ReactModal);

  function ScholarshipModal(block) {
    var _this;

    babelHelpers.classCallCheck(this, ScholarshipModal);
    _this = babelHelpers.possibleConstructorReturn(this, babelHelpers.getPrototypeOf(ScholarshipModal).call(this));
    _this.removeOnHide = true;
    _this.classList = _this.classList.concat('survey-modal');

    _this.setComponent(_react.default.createElement(ScholarshipApplicationModalBody, _extends({
      modal: babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this))
    }, block)));

    return _this;
  }

  babelHelpers.createClass(ScholarshipModal, [{
    key: "title",
    get: function get() {
      return "";
    }
  }]);
  return ScholarshipModal;
}(_base.ReactModal);

var Features = (_class = (_temp =
/*#__PURE__*/
function (_Component) {
  babelHelpers.inherits(Features, _Component);

  function Features() {
    var _babelHelpers$getProt;

    var _this2;

    babelHelpers.classCallCheck(this, Features);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this2 = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt = babelHelpers.getPrototypeOf(Features)).call.apply(_babelHelpers$getProt, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this2, "items", _descriptor, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this2)));
    return _this2;
  }

  babelHelpers.createClass(Features, [{
    key: "render",
    value: function render() {
      if (!this.items.length) return null;
      return _react.default.createElement("div", {
        className: "features"
      }, this.items.map(function (item) {
        return _react.default.createElement(Feature, _extends({
          key: item.id
        }, item));
      }));
    }
  }]);
  return Features;
}(_react.Component), _temp), (_descriptor = babelHelpers.applyDecoratedDescriptor(_class.prototype, "items", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class);
exports.Features = Features;
var Feature = (_class3 = (_temp2 =
/*#__PURE__*/
function (_Component2) {
  babelHelpers.inherits(Feature, _Component2);

  function Feature() {
    var _babelHelpers$getProt2;

    var _this3;

    babelHelpers.classCallCheck(this, Feature);

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    _this3 = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt2 = babelHelpers.getPrototypeOf(Feature)).call.apply(_babelHelpers$getProt2, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this3, "icon", _descriptor2, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this3)));
    babelHelpers.initializerDefineProperty(_this3, "title", _descriptor3, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this3)));
    babelHelpers.initializerDefineProperty(_this3, "summary", _descriptor4, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this3)));
    return _this3;
  }

  babelHelpers.createClass(Feature, [{
    key: "render",
    value: function render() {
      return _react.default.createElement("div", {
        className: "feature"
      }, _react.default.createElement("header", null, this.icon && _react.default.createElement("div", {
        className: "feature-icon",
        style: {
          backgroundImage: "url(".concat(this.icon, ")")
        }
      }), _react.default.createElement("div", {
        className: "feature-title"
      }, this.title)), _react.default.createElement("div", {
        className: "feature-body"
      }, _react.default.createElement("p", {
        dangerouslySetInnerHTML: {
          __html: this.summary
        }
      })));
    }
  }]);
  return Feature;
}(_react.Component), _temp2), (_descriptor2 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "icon", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "title", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "summary", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class3);
var PeopleList = (_class5 = (_temp3 =
/*#__PURE__*/
function (_Component3) {
  babelHelpers.inherits(PeopleList, _Component3);

  function PeopleList() {
    var _babelHelpers$getProt3;

    var _this4;

    babelHelpers.classCallCheck(this, PeopleList);

    for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }

    _this4 = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt3 = babelHelpers.getPrototypeOf(PeopleList)).call.apply(_babelHelpers$getProt3, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this4, "title", _descriptor5, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this4)));
    babelHelpers.initializerDefineProperty(_this4, "items", _descriptor6, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this4)));
    return _this4;
  }

  babelHelpers.createClass(PeopleList, [{
    key: "render",
    value: function render() {
      if (this.items.length) {
        return _react.default.createElement("div", {
          className: "people"
        }, this.title && _react.default.createElement("h2", {
          className: "section-title"
        }, this.title), this.items.map(function (item) {
          return _react.default.createElement(Person, _extends({}, item, {
            key: item.id
          }));
        }));
      }

      return null;
    }
  }]);
  return PeopleList;
}(_react.Component), _temp3), (_descriptor5 = babelHelpers.applyDecoratedDescriptor(_class5.prototype, "title", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = babelHelpers.applyDecoratedDescriptor(_class5.prototype, "items", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class5);
exports.PeopleList = PeopleList;
var Person = (_class7 = (_temp4 =
/*#__PURE__*/
function (_Component4) {
  babelHelpers.inherits(Person, _Component4);

  function Person() {
    var _babelHelpers$getProt4;

    var _this5;

    babelHelpers.classCallCheck(this, Person);

    for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
      args[_key4] = arguments[_key4];
    }

    _this5 = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt4 = babelHelpers.getPrototypeOf(Person)).call.apply(_babelHelpers$getProt4, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this5, "link", _descriptor7, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this5)));
    babelHelpers.initializerDefineProperty(_this5, "photo", _descriptor8, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this5)));
    babelHelpers.initializerDefineProperty(_this5, "name", _descriptor9, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this5)));
    babelHelpers.initializerDefineProperty(_this5, "icons", _descriptor10, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this5)));
    babelHelpers.initializerDefineProperty(_this5, "title", _descriptor11, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this5)));
    babelHelpers.initializerDefineProperty(_this5, "location", _descriptor12, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this5)));
    babelHelpers.initializerDefineProperty(_this5, "bio", _descriptor13, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this5)));
    return _this5;
  }

  babelHelpers.createClass(Person, [{
    key: "render",
    value: function render() {
      var LinkNode = "div";
      var LinkAttrs = {};

      if (this.link) {
        LinkNode = "a";
        LinkAttrs = {
          href: this.link
        };
      }

      return _react.default.createElement("div", {
        className: "person"
      }, _react.default.createElement("div", {
        className: "person-photo"
      }, _react.default.createElement(LinkNode, LinkAttrs, _react.default.createElement(_ProfileImageContainer.default, {
        className: "image",
        noImageClassName: "initials",
        image: this.photo,
        name: this.name
      }))), _react.default.createElement("div", {
        className: "person-body"
      }, _react.default.createElement("div", {
        className: "person-name"
      }, _react.default.createElement(LinkNode, LinkAttrs, this.name, this.icons.length > 0 && _react.default.createElement("span", {
        className: "account-icon-list"
      }, this.icons.map(function (icon) {
        return _react.default.createElement("img", {
          className: "account-icon",
          key: icon.id,
          src: icon.icon,
          title: icon.title
        });
      })))), this.title && _react.default.createElement("div", {
        className: "person-title"
      }, this.title), this.location && _react.default.createElement("div", {
        className: "person-location"
      }, this.location), this.bio && _react.default.createElement("div", {
        className: "person-bio"
      }, this.bio)));
    }
  }]);
  return Person;
}(_react.Component), _temp4), (_descriptor7 = babelHelpers.applyDecoratedDescriptor(_class7.prototype, "link", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = babelHelpers.applyDecoratedDescriptor(_class7.prototype, "photo", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = babelHelpers.applyDecoratedDescriptor(_class7.prototype, "name", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = babelHelpers.applyDecoratedDescriptor(_class7.prototype, "icons", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = babelHelpers.applyDecoratedDescriptor(_class7.prototype, "title", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor12 = babelHelpers.applyDecoratedDescriptor(_class7.prototype, "location", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor13 = babelHelpers.applyDecoratedDescriptor(_class7.prototype, "bio", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class7);
exports.Person = Person;
var ScholarshipApplicationModalBody = (_class9 = (_temp5 =
/*#__PURE__*/
function (_ApplicationHeaderBlo) {
  babelHelpers.inherits(ScholarshipApplicationModalBody, _ApplicationHeaderBlo);

  function ScholarshipApplicationModalBody() {
    var _babelHelpers$getProt5;

    var _this6;

    babelHelpers.classCallCheck(this, ScholarshipApplicationModalBody);

    for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
      args[_key5] = arguments[_key5];
    }

    _this6 = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt5 = babelHelpers.getPrototypeOf(ScholarshipApplicationModalBody)).call.apply(_babelHelpers$getProt5, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this6, "applicationName", _descriptor14, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this6)));
    babelHelpers.initializerDefineProperty(_this6, "catalog", _descriptor15, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this6)));
    babelHelpers.initializerDefineProperty(_this6, "modal", _descriptor16, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this6)));
    return _this6;
  }

  babelHelpers.createClass(ScholarshipApplicationModalBody, [{
    key: "getChildren",
    value: function getChildren() {
      return _react.default.createElement("div", {
        className: "survey-body"
      }, _react.default.createElement("div", {
        className: "survey-header"
      }, _react.default.createElement("div", null, _react.default.createElement("h1", {
        className: "survey-header"
      }, this.applicationName), _react.default.createElement("div", {
        className: "catalog-item"
      }, _react.default.createElement("div", {
        className: "photo"
      }, _react.default.createElement("div", {
        className: "list-image",
        style: {
          backgroundImage: "url(".concat(this.catalog.image, ")")
        }
      })), _react.default.createElement("div", {
        className: "catalog-item-info"
      }, _react.default.createElement("div", {
        className: "catalog-item-title"
      }, this.catalog.title))))), _react.default.createElement("div", {
        className: "scholarship-body-text"
      }, _react.default.createElement("div", {
        dangerouslySetInnerHTML: {
          __html: this.catalog.applicationText
        }
      })), _react.default.createElement("div", {
        className: "form-submit"
      }, _react.default.createElement("div", {
        className: "purchase-wrap"
      }, _react.default.createElement(ObjectDetailButton, _extends({}, this.state.purchaseButtonInfo, {
        modal: this.modal
      })))));
    }
  }]);
  return ScholarshipApplicationModalBody;
}(_applicationHeader.default), _temp5), (_descriptor14 = babelHelpers.applyDecoratedDescriptor(_class9.prototype, "applicationName", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor15 = babelHelpers.applyDecoratedDescriptor(_class9.prototype, "catalog", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor16 = babelHelpers.applyDecoratedDescriptor(_class9.prototype, "modal", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class9);
var ObjectDetailButton = (_class11 = (_temp6 =
/*#__PURE__*/
function (_ObjectDetailButtonBa) {
  babelHelpers.inherits(ObjectDetailButton, _ObjectDetailButtonBa);

  function ObjectDetailButton() {
    var _babelHelpers$getProt6;

    var _this7;

    babelHelpers.classCallCheck(this, ObjectDetailButton);

    for (var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
      args[_key6] = arguments[_key6];
    }

    _this7 = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt6 = babelHelpers.getPrototypeOf(ObjectDetailButton)).call.apply(_babelHelpers$getProt6, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this7, "modal", _descriptor17, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this7)));
    return _this7;
  }

  babelHelpers.createClass(ObjectDetailButton, [{
    key: "showApplication",
    value: function showApplication(event) {
      var _this8 = this;

      if (!this.modal) return babelHelpers.get(babelHelpers.getPrototypeOf(ObjectDetailButton.prototype), "showApplication", this).call(this, event);
      event.preventDefault();
      babelHelpers.get(babelHelpers.getPrototypeOf(ObjectDetailButton.prototype), "showApplication", this).call(this).then(function (r) {
        _this8.modal.hide();

        return r;
      });
    }
  }]);
  return ObjectDetailButton;
}(_ObjectDetailBar.ObjectDetailButton), _temp6), (_descriptor17 = babelHelpers.applyDecoratedDescriptor(_class11.prototype, "modal", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), babelHelpers.applyDecoratedDescriptor(_class11.prototype, "showApplication", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class11.prototype, "showApplication"), _class11.prototype)), _class11);